import { render, staticRenderFns } from "./PageServerError.vue?vue&type=template&id=19cf6caa&scoped=true&"
import script from "./PageServerError.vue?vue&type=script&lang=js&"
export * from "./PageServerError.vue?vue&type=script&lang=js&"
import style0 from "./PageServerError.vue?vue&type=style&index=0&id=19cf6caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf6caa",
  null
  
)

export default component.exports